import { fetchAPI } from "../../../../config/axios";
import { TAction, TDispatch } from "../../../types";
import {
  GetReportAllAction,
  GetReportAllModel,
  GetReportAllType,
} from "./types";

export const GetAllReportDefault: GetReportAllModel = {
  rcsa: {
    data: {},
  },
  led: {
    data: {},
  },
  kri: {
    data: {},
  },
};

export const ReportAllReducer = (
  state: GetReportAllModel = GetAllReportDefault,
  action: GetReportAllAction
): GetReportAllModel => {
  switch (action.type) {
    case GetReportAllType.GetReportRCSA:
      return { ...state, rcsa: action.data };
    case GetReportAllType.GetReportLED:
      return { ...state, led: action.data };
    case GetReportAllType.GetReportKRI:
      return { ...state, kri: action.data };
    default:
      return { ...state };
  }
};

export const ReportAllCommand = {
  GetAllReport: (params: any): TAction<GetReportAllAction, void> => {
    return (dispatch: TDispatch<GetReportAllAction>) => {
      return fetchAPI()
        .post(`/get-all-report/${params.key}`, { ...params.body })
        .then((response) => {
          if (params.key.includes("rcsa")) {
            let type = GetReportAllType.GetReportRCSA;
            dispatch({
              data: response.data,
              type: type,
            });
          } else if (params.key.includes("led")) {
            let type = GetReportAllType.GetReportLED;
            dispatch({
              data: response.data,
              type: type,
            });
          } else if (params.key.includes("kri")) {
            let type = GetReportAllType.GetReportKRI;
            dispatch({
              data: response.data,
              type: type,
            });
          }
        });
    };
  },
};
